import "./Newsletter.scss";

import { Link } from "react-router-dom";
import May from "../../assets/newsletters/MPHCA Newsletter May 2026.pdf";
import June from "../../assets/newsletters/MPHCA Newsletter June 2026.pdf";

function NewsLetter() {
  return (
    <div className="newsletter">
      <a href={May}>
        <button className="newsletter__button">May Newsletter</button>
      </a>
      <a href={June}>
        <button className="newsletter__button">June Newsletter</button>
      </a>

      <Link to="/anti-racism">
        <button className="newsletter__button">Anti Racism Charter</button>
      </Link>
    </div>
  );
}

export default NewsLetter;
